import header from "./vi/header"
import navBar from "./vi/navBar"
import error from "./vi/error"
import commons from "./vi/commons"
import market from "./vi/market"

export default {
  translation: {
    ...header,
    ...navBar,
    ...error,
    ...commons,
    ...market,
  }
}